import { FC } from 'react';

import { H2, Tooltip } from '@smartshell/ui-kit';
import cn from 'classnames';

import { ISummaryBlockProps } from './interfaces';
import s from './ReportSummaryBlock.module.scss';

export const ReportSummaryBlock: FC<ISummaryBlockProps> = ({ item }) => {
  return (
    <>
      {item.tooltip ? (
        <Tooltip
          position="bottom-left"
          content={item.tooltip}
          contentClassName={s.tooltip}
          className={s.tooltip_root}
        >
          <div
            className={cn(s.block, item.tooltip && s.border)}
            key={item.text}
          >
            <div className={cn(s.left, item.color && s[item.color])}>
              {item.icon}
            </div>
            <div className={s.right}>
              <H2 className={s.title}>
                {item.value}
                {item.percent && (
                  <span className={s.percent}>{item.percent}</span>
                )}
              </H2>
              <span className={s.text}>{item.text}</span>
            </div>
          </div>
        </Tooltip>
      ) : (
        <div className={cn(s.block, item.tooltip && s.border)} key={item.text}>
          <div className={cn(s.left, item.color && s[item.color])}>
            {item.icon}
          </div>
          <div className={s.right}>
            <H2 className={s.title}>
              {item.value}
              {item.percent && (
                <span className={s.percent}>{item.percent}</span>
              )}
            </H2>
            <span className={s.text}>{item.text}</span>
          </div>
        </div>
      )}
    </>
  );
};
